












































































































































































































































































































































































































































import EventBus from '@/eventBus';
import axios from 'axios';
import { get, uniq, map, clone, xorBy } from 'lodash';
import { addHours, format, roundToNearestMinutes } from 'date-fns';
import { isValidExternalUrl, normalizeUrlProtocol } from '@/utils/url';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoTagList from '@/components/Organisms/co-TagList/coTagList.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';
import CoEventTicketCreateEdit from '@/components/Organisms/co-event-ticket-create-edit/CoEventTicketCreateEdit.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';

export default {
    name: 'EventCreate',
    components: {
        CoButton,
        CoRoundButton,
        CoHeadline,
        CoCard,
        CoFormGroup,
        CoInput,
        CoSelect,
        CoTagList,
        CoTable,
        CoText,
        CoAlert,
        CoEventTicketCreateEdit,
        CoDropdown,
        CoDropdownItem,
    },
    props: {
        me: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    data() {
        return {
            event: {},

            types: [],
            selectedType: null,
            locations: [],
            selectedLocation: '',
            customLocation: {
                Name: '',
                Address: '',
                ZipCode: '',
                City: '',
                Country: '',
            },

            todayDate: roundToNearestMinutes(new Date(), { nearestTo: 30, roundingMethod: 'ceil' })
                .toISOString()
                .split('T')[0],
            startDate: '',
            startTime: '',

            endDate: '',
            endTime: '',

            taxRates: [],

            loading: false,
            loadingTaxRate: false,
            ticketsLoading: false,
            rerenderTickets: 0,
            toogleShareInFeed: false,
            ticketingMode: 'rsvp', // internal, external or rsvp
            eventFormatMode: 'physical', // physical, online or hybrid
        };
    },
    watch: {
        startDate(val) {
            // if end date is before start date, set end date to start date

            // convert to timestamp
            const start = new Date(val);
            const end = new Date(this.endDate);

            if (end < start) {
                this.endDate = val;
            }
        },

        startTime(val) {
            // if end time is before start time, set end time to start time
            // compose start date and time
            const start = new Date(`${this.startDate}T${this.startTime}`);
            const end = new Date(`${this.endDate}T${this.endTime}`);
            // convert to timestamp

            if (end <= start) {
                const tmp = addHours(start, 1);
                this.endTime = format(tmp, 'HH:mm');
            }
        },
        types(val) {
            this.restoreCopiedEventType(val);
        },
        ticketingMode(val) {
            if (val === 'internal') {
                if (!this.event.Tickets || !this.event.Tickets.length) {
                    // add default ticket if no tickets exist yet when switching to internal mode
                    this.event.Tickets = [
                        {
                            Name: this.$t('labels.freeticket'),
                            PriceInCents: 0,
                            Limit: 100,
                            CancellationNotice: 7,
                        },
                    ];
                }
            }
        },
    },
    computed: {
        ticketColumns() {
            if (this.$isMobile) {
                return [
                    { key: 'Name', title: this.$t('labels.name') },
                    { key: 'actions', title: '', class: 'text-right' },
                ];
            }

            return [
                { key: 'Name', title: this.$t('labels.name') },
                { key: 'price', title: this.$t('labels.price') },
                { key: 'VAT', title: this.$t('labels.vat') },
                { key: 'actions', title: '', class: 'text-right' },
            ];
        },
        amIAdmin() {
            return get(this.me, 'Permissions', '').includes('space_admin');
        },
        canICreate() {
            if (this.loading) {
                return false;
            }
            // check if name is set
            // check if start date is set and in the future
            // check if end date is set and in the future and after start date
            if (!this.event.Title) {
                return false;
            }

            if (!this.startDate) {
                return false;
            }

            if (!this.startTime) {
                return false;
            }

            if (!this.endDate) {
                return false;
            }

            if (!this.endTime) {
                return false;
            }

            // compose start date and time
            const start = new Date(`${this.startDate}T${this.startTime}`);
            const end = new Date(`${this.endDate}T${this.endTime}`);

            if (end < start) {
                return false;
            }

            if (
                (this.eventFormatMode === 'online' || this.eventFormatMode === 'hybrid') &&
                !this.isValidLink(this.event.ExternalLink)
            ) {
                return false;
            }
            return true;
        },
        eventFormatModeHybrid() {
            return this.eventFormatMode === 'hybrid';
        },
        eventFormatModeOnline() {
            return this.eventFormatMode === 'online';
        },
        eventFormatModePhysical() {
            return this.eventFormatMode === 'physical';
        },
        ticketingModeInternal() {
            return this.ticketingMode === 'internal';
        },
        ticketingModeExternal() {
            return this.ticketingMode === 'external';
        },
        ticketingModeRsvp() {
            return this.ticketingMode === 'rsvp';
        },
    },
    created() {
        this.getEventTypes();
        this.getLocations();
        this.getTaxRates();
    },
    mounted() {
        // time utility
        let start, end;
        // start time is now
        const now = roundToNearestMinutes(new Date(), { nearestTo: 15, roundingMethod: 'ceil' });
        const nowPlusOneHour = addHours(now, 1);

        // if eventDuplicate is set in the store, seed the form with duplicated event data
        if (this.$store?.state?.eventDuplicate) {
            const tickets = this.$store?.state?.eventDuplicate?.Tickets || [];
            this.event = {
                ...this.$store.state.eventDuplicate,
                Tickets: tickets.map((ticket) => {
                    // Clean duplicated ticket payloads so the create flow can persist them as new records.
                    if (typeof ticket === 'object' && ticket['ID']) {
                        delete ticket['ID'];
                        delete ticket['EventID'];
                        return ticket;
                    }

                    return ticket;
                }),
            };

            this.restoreCopiedEventType();
            this.initializeTicketingMode();

            // handle duplicated event start and end date
            start = parseInt(this.event?.StartDate || '0') * 1000;
            end = parseInt(this.event?.EndDate || '0') * 1000;

            // Preselect duplicated locations before the async location list is appended.
            if (this.event?.Location?.length) {
                this.locations.unshift({
                    Name: this.event.Location,
                    Value: this.event.Location,
                    Disabled: false,
                });
                this.selectLocation(this.locations[0]);
            }

            // clone and add duplicated tags
            const duplicatedTags = this.event?.Tags?.length ? clone(this.event.Tags) : [];
            duplicatedTags.forEach((tag) => {
                if (this.$refs.userTagList) {
                    this.$refs.userTagList.addTag(tag);
                }
            });

            // Remove the temporary duplicate payload once the create form has consumed it.
            this.$store.state.eventDuplicate = null;
        }

        if ((!this.event.Tickets || !this.event.Tickets.length) && this.ticketingMode === 'internal') {
            // add default ticket if no tickets exist yet when switching to internal mode
            this.event.Tickets = [
                {
                    Name: this.$t('labels.freeticket'),
                    PriceInCents: 0,
                    Limit: 100,
                    CancellationNotice: 7,
                },
            ];
        }

        this.initializeEventFormatMode();

        // set start and end date and time
        this.startDate = format(start || now, 'yyyy-MM-dd');
        this.endDate = format(end || nowPlusOneHour, 'yyyy-MM-dd');
        this.startTime = format(start || now, 'HH:mm');
        this.endTime = format(end || nowPlusOneHour, 'HH:mm');

        // set focus to title
        this.$refs.title.focus();
    },
    methods: {
        get,
        removeEventTicket(ticket) {
            // Remount the table after ticket mutations because CoTable keeps internal ordered state.
            this.event.Tickets = (this.event.Tickets || []).filter((t) => t.ID !== ticket.ID);
            this.rerenderTickets += 1;
        },
        restoreCopiedEventType(types = this.types) {
            const copiedEventType = get(this.event, 'EventType[0]', null);

            if (!copiedEventType) {
                return;
            }

            const matchingType =
                types.find((type) => type.Value === copiedEventType) ||
                types.find((type) => type.Name === copiedEventType);

            if (matchingType) {
                // Prefer the canonical option object when the event type list is available.
                this.selectedType = matchingType;
            }
        },
        initializeTicketingMode() {
            // Restore the copied participation mode before the form applies its defaults.
            if (this.event?.TicketingMode === 3) {
                this.ticketingMode = 'internal';
                return;
            }

            if (this.event?.TicketingMode === 2) {
                this.ticketingMode = 'external';
                return;
            }

            if (this.event?.TicketingMode === 1) {
                this.ticketingMode = 'rsvp';
                return;
            }

            const hasTickets = (this.event?.Tickets || []).some((ticket) => !ticket.Deleted);
            const hasExternalUrl = Boolean(get(this.event, 'FullURL', ''));

            if (hasTickets) {
                this.ticketingMode = 'internal';
                return;
            }

            if (hasExternalUrl) {
                this.ticketingMode = 'external';
                return;
            }

            this.ticketingMode = 'rsvp';
        },
        initializeEventFormatMode() {
            const hasLocation = Boolean(get(this.event, 'Location', '') || get(this.selectedLocation, 'Value', ''));
            const hasVideoLink = Boolean(get(this.event, 'ExternalLink', ''));

            if (hasLocation && hasVideoLink) {
                this.eventFormatMode = 'hybrid';
                return;
            }

            if (hasVideoLink) {
                this.eventFormatMode = 'online';
                return;
            }

            this.eventFormatMode = 'physical';
        },

        isValidLink(value) {
            return isValidExternalUrl(value);
        },
        normalizeEventLinks() {
            // Normalize user-entered links once before persisting so display and API payloads stay consistent.
            this.event.FullURL = normalizeUrlProtocol(this.event.FullURL);
            this.event.ExternalLink = normalizeUrlProtocol(this.event.ExternalLink);
        },
        updateEventTicket(newTicket) {
            // replace ticket in event.Tickets with new ticket by ID
            this.event.Tickets = this.event.Tickets.map((ticket) => {
                if (ticket.ID === newTicket.ID) {
                    return newTicket;
                }
                return ticket;
            });

            this.ticketsLoading = true;
            this.ticketsLoading = false;
            this.rerenderTickets += 1;
        },
        createEventTicket(ticket) {
            this.ticketsLoading = true;
            if (!this.event.Tickets) {
                this.event.Tickets = [];
            }
            this.event.Tickets.push(ticket);
            this.ticketsLoading = false;
            this.rerenderTickets += 1;
        },

        getTaxRateForTicket(ticket) {
            const taxrate = this.taxRates.find((taxrate) => taxrate.ID === ticket.TaxRateID);

            if (!taxrate) {
                return '-';
            }

            if (!taxrate.Percentage) {
                return '0%';
            }

            return `${taxrate.Percentage}%`;
        },
        discard() {
            if (window.history.length > 2) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        saveAsDraft() {
            this.event.Draft = true;
            this.toogleShareInFeed = false;
            this.createEvent();
        },
        saveAndPublish() {
            this.event.Draft = false;
            this.toogleShareInFeed = true;
            this.createEvent();
        },
        selectType(type) {
            this.selectedType = type;
        },
        selectLocation(location) {
            this.selectedLocation = location;
        },
        tagsChanged(tags) {
            const tmp = uniq(tags);
            this.event.Tags = tmp;
        },
        isEnabled(feature) {
            if (!this.$unleash) {
                console.error('Unleash not available');
                return false;
            }
            return this.$unleash.isEnabled(feature);
        },

        createEvent() {
            this.loading = true;
            if (!this.$store) {
                console.error('Store not available');
                this.loading = false;
                return;
            }

            if (this.selectedType) {
                this.event.EventType = [this.selectedType.Value];
            } else {
                // Clear copied event types that no longer exist so the form does not resubmit stale values.
                this.event.EventType = [];
            }

            this.normalizeEventLinks();

            if (this.eventFormatMode === 'physical' || this.eventFormatMode === 'hybrid') {
                if (get(this.selectedLocation, 'Value', '') === 'custom') {
                    this.event.Location = '';
                    if (this.customLocation.Name) {
                        this.event.Location += `${this.customLocation.Name}`;
                    }
                    if (this.customLocation.Address) {
                        this.event.Location += `${this.event.Location ? ', ' : ''}${this.customLocation.Address}`;
                    }
                    if (this.customLocation.ZipCode) {
                        this.event.Location += `${this.event.Location ? ', ' : ''}${this.customLocation.ZipCode}`;
                    }
                    if (this.customLocation.City) {
                        if (this.customLocation.ZipCode) {
                            this.event.Location += ` `;
                        } else {
                            this.event.Location += `, `;
                        }
                        this.event.Location += `${this.customLocation.City}`;
                    }
                    if (this.customLocation.Country) {
                        this.event.Location += `${this.event.Location ? ', ' : ''}${this.customLocation.Country}`;
                    }
                } else {
                    this.event.Location = this.selectedLocation?.Name || '';
                }
            } else {
                this.event.Location = '';
            }

            const start = new Date(`${this.startDate}T${this.startTime}`);
            const end = new Date(`${this.endDate}T${this.endTime}`);
            // convert to unix timestamp
            this.event.StartDate = start.getTime();
            this.event.EndDate = end.getTime();

            // devide by 1000 to get seconds and round to integer and covert to string
            this.event.StartDate = Math.round(this.event.StartDate / 1000).toString();
            this.event.EndDate = Math.round(this.event.EndDate / 1000).toString();

            if (this.ticketingMode === 'rsvp') {
                this.event.Tickets = [];
                this.event.FullURL = '';
                this.event.TicketingMode = 1; // RSVPs
            } else if (this.ticketingMode === 'external') {
                this.event.Tickets = null;
                this.event.TicketingMode = 2; // External URL
            } else if (this.ticketingMode === 'internal') {
                this.event.FullURL = '';
                this.event.TicketingMode = 3; // Internal ticketing
            }

            if (this.eventFormatMode === 'physical') {
                this.event.ExternalLink = '';
            } else if (this.eventFormatMode === 'online') {
                this.event.Location = '';
            }

            this.$store
                .dispatch('createEvent', this.event)
                .then((response) => {
                    const message = {
                        Message: this.$t('labels.eventcreated'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    const query = this.toogleShareInFeed ? { toogleShareInFeed: 'true' } : undefined;
                    this.$router.push({ path: `/event/${response.Slug}`, query });

                    this.loading = false;
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.eventCreateFailed'),
                        Details: error,
                    };
                    EventBus.$emit('ERROR', message);
                    this.loading = false;
                });
        },

        getEventTypes() {
            axios
                .get('/event/type/list')
                .then((response) => {
                    if (response && response.data && response.data.objects) {
                        this.types = response.data.objects.map((type) => ({
                            Name: type.Value,
                            Value: type.Slug,
                            Disabled: false,
                        }));
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {});
        },

        getLocations() {
            axios
                .get('/booking/locations')
                .then((response) => {
                    if (response?.data?.Locations) {
                        this.locations = this.locations.concat(
                            response.data.Locations.map((location) => ({
                                Name: location.Address ? `${location.Name}, ${location.Address}` : location.Name,
                                Value: location.Address ? `${location.Name}, ${location.Address}` : location.Name,
                                Disabled: false,
                                Address: location.Address ? location.Address : '',
                            }))
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    // if no custom location in list then
                    // add custom location
                    if (!this.locations.find((l) => l.Value === 'custom')) {
                        this.locations.push({
                            Name: this.$t('labels.addaddress'),
                            Value: 'custom',
                            Disabled: false,
                        });
                    }
                });
        },

        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/space/tax/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                    console.log(error);
                });
        },
    },
};
